export const ARROW_CONFIG = {
  bow: 0,
  stretch: 0.3,
  stretchMin: 40,
  stretchMax: 420,
  padStart: 0,
  padEnd: 6,
  straights: false,
  flip: false
};

export const TETHER_LENGTH = 16;
export const DOT_SIZE = 3;
export const HANDLE_SIZE = 8;
export const MOUSE_BUFFER = 4;